import React, { useState } from "react";
import { stytchService } from '../../utils/stytchService';
import { useContentSize, saveContentSize } from "../../hooks/useContentSize";
import { encryptAndStoreToken } from "../../utils/tokenEncryptionUtils";
import OTPCodeVerificationView from "./OTPVerificationView";
import LoadingUserComponent from "./LoadingUser";

interface Props {
  email: string;
  stytchMethodId: string;
  onCodeAuthenticated: () => void;
  onBackToLogin: () => void;
}

const OTPVerificationContainer: React.FC<Props> = ({
  email,
  stytchMethodId,
  onCodeAuthenticated,
  onBackToLogin,
}) => {
  const { ref: contentRef, size: contentSize } = useContentSize();

  const [verificationCode, setVerificationCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const saveCardSize = () => {
    saveContentSize(contentRef);
  };

  const onCodeSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    saveCardSize();
    setLoading(true);
    setError(null);

    try {
      // Make the call to stytch to authenticate the code.
      const response = await stytchService.authenticateCode(verificationCode, stytchMethodId);
      console.log("[OTPVerificationContainer] Code verification response:", response);

      if (response) {

        // Store JWT in localStorage for API authentication
        encryptAndStoreToken(response.session_jwt);
        localStorage.setItem("stytch_session", response.session_token);

        // Finish
        onCodeAuthenticated();
      }
    } catch (err) {
      console.error("[OTPVerificationContainer] Code verification error:", err);
      setError("Please enter a valid code.");
      setLoading(false);
    }
  };

  const onCodeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.replace(/\D/g, "").slice(0, 6);
    setVerificationCode(value);
  };

  const onCodeResend = async () => {
    try {
      const response = await stytchService.startEmailLogin(email);
      if (response && response.status_code === 200) {
        setError("Code resent successfully. Please check your email.");
      } else {
        setError("Failed to resend code. Please try again later.");
      }
    } catch (error) {}
  };

  return loading ? (
    <div
      style={{
        minHeight: contentSize?.height || "auto",
        minWidth: contentSize?.width || "auto",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <LoadingUserComponent />
    </div>
  ) : (
    <div ref={contentRef} className="user-login-container">
      <OTPCodeVerificationView
        email={email}
        error={error}
        verificationCode={verificationCode}
        onCodeSubmit={onCodeSubmit}
        onCodeChange={onCodeChange}
        onCodeResend={onCodeResend}
        onBackToLogin={onBackToLogin}
      />
    </div>
  );
};

export default OTPVerificationContainer;
